import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PhAuthService } from '../ph-auth.service';

@Injectable()
export class PhAuthSdkService implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private phAuthSrv: PhAuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.setupAuthFlow();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setupAuthFlow(): void {
    // Handle successful authentication
    this.phAuthSrv.whenAuthenticated$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const next = this.activatedRoute.snapshot.queryParams.next;
        this.router.navigateByUrl(next || '/');
      });

    // Initial token fetch
    this.getNewToken();

    // Setup token refresh
    this.phAuthSrv.jwt$
      .pipe(takeUntil(this.destroy$))
      .subscribe((jwt) => {
        if (jwt) {
          const expirationTime = jwt.exp! * 1000;
          const currentTime = new Date().getTime();
          const timeUntilExpiration = expirationTime - currentTime;

          // If token is about to expire in less than 5 minutes, refresh it
          if (timeUntilExpiration < 5 * 60 * 1000) {
            this.getNewToken();
          }
        }
      });
  }

  private getNewToken(): void {
    this.phAuthSrv.getAccessTokenSilently()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (token) => this.phAuthSrv.setToken(token),
        error: (err) => {
          console.warn('Was not possible to get token silently:', err);
          console.log('Redirecting to login...');
          this.phAuthSrv.loginWithRedirect();
        }
      });
  }
}
